// @react/hooks/useProjectMilestone.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { projectMilestoneStore } from '@core/stores';

/**
 * React hook for Milestone operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useProjectMilestone } from '@react/hooks';
 *
 * const MilestoneList = observer(() => {
 *   const store = useProjectMilestone();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useProjectMilestone() {
  return projectMilestoneStore;
}
